/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import Wait from '@react/react-spectrum/Wait';
import React, {useState} from 'react';
import Banner from '@react/react-spectrum/Banner';
import './AppHomeCard.scss';

type Props = {
	key: string;
	text: string;
	link: string;
	imgUrl: string;
	type: string;
	title: string;
	loadDelay: number;
	comingSoon?: boolean;
	spinner: boolean;
	apphomeData: any;
	intl: any;
};

export const AppHomeCard = (props: Props) => {
	const [isLoading, setLoading] = useState(false);

	const handleDelay = async(e) => {
		if (props.comingSoon) {
			e.preventDefault();
			return false;
		}
		e.preventDefault();
		setLoading(true);
		await new Promise(res => setTimeout(res, props.spinner ? props.loadDelay : 0));
		window.location.href = props.link;
	};

	return (
		<button
			key={`apphome-card-${props.key}`}
			className='apphome-card'
			onClick={handleDelay}
			tabIndex={0}
			role='link'
			aria-label={props.text}
		>
			<p className='apphome-card-text'>
				<span className='apphome-card-faded-text'>{props.title}</span>
				<span className='apphome-card-title'>{props.text}</span>
			</p>
			<div className='apphome-card-img-container' tabIndex={-1} >
				<img className='apphome-card-img' src={props.imgUrl} alt={props.text} />
			</div>
			{props.spinner && isLoading && (
				<div className='apphome-card-loading'>
					<Wait size='M' centered variant='overBackground' />
				</div>
			)}
			{props.comingSoon && (
				<div className='apphome-card-banner-container'>
					<Banner
						className='apphome-card-banner'
						corner
						content={props.intl.formatMessage({id: 'app.apphomes.soon'})}
					/>
				</div>
			)}
		</button>
	);
};

export default AppHomeCard;
